// extracted by mini-css-extract-plugin
export default {"root":"T99HiXcY","trigger":"yrmIzp6G","signOut":"gsRSSPWH","version":"m6pIy56b"};